import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
//import '../content/css/WildRadioButtons.css';

export default class TextInputBox extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.text
        };
    }

    getValidationState() {
        /*const length = this.state.value.length;
        if (length > 10) return 'success';
        if (length > 5) return 'warning';
        if (length > 0) return 'error';*/
        return null;
    }

    handleChange = (e) => {
        //this.setState({ value: e.target.value });
        this.props.onChange(e.target.value);
    }

    render() {
        return (
            <div>
                <FormGroup
                    controlId="formBasicText"
                    validationState={this.getValidationState()}
                >
                    {!this.props.title &&
                        <ControlLabel>{this.props.title}</ControlLabel>
                    }
                    <FormControl
                        type="text"
                        placeholder={this.props.placeholder}
                        onChange={this.handleChange}
                    />
                    <FormControl.Feedback />
                    <HelpBlock>{this.props.helpText}</HelpBlock>
                </FormGroup>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TextInputBox.js